import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ApisService } from './services/apis.service';
import { ElectronService } from './services/electron.service';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApisService,
    private electronService: ElectronService,
  ) { }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      take(1)
    ).subscribe(() => {
      const currentUrl = this.router.url;

      this.apiService.observableLoggedIn.subscribe(data => {
        if (data.user_id === null && !currentUrl.startsWith('/auth/callback')) {
          this.router.navigate(['login']);
        } else if (data.user_id !== null) {
          this.router.navigate(['']);
        }
      });
    });

    if (this.electronService.isElectron()) {
      console.log('[ DEBUG ] Electron Mode');
      // console.log('[ DEBUG ] Electron ipcRenderer', electronService.ipcRenderer);
      // console.log('[ DEBUG ] NodeJS childProcess', electronService.childProcess);
    } else {
      console.log('[ DEBUG ] Browser Mode');
    }
  }
}
